import { IconButton, IconButtonProps } from "--components/buttons/iconButton";
import { RenderElementProps } from "slate-react";
import styled from "styled-components";

export const StyledMention = styled.a.attrs({ "contentEditable": "false", "spellCheck": "false" }) <{ color: string, hasAction?: boolean } & Partial<RenderElementProps["attributes"]>>`
	display: inline-flex;
	justify-content: flex - start;
	user-select: none;
	align-items: center;
	flex-direction: row;
	flex-wrap: nowrap;
	padding: ${props => props.hasAction ? "0px 2px 0px 8px" : "0px 2px"};
	margin: 0px ${props => props.theme.spacing(0.5)};
	border-radius: 4px;

	// Foreground color (Groups = primary | Individuals = link | Topics = positive)
	color: ${props => props.theme.palette.white};

	// Background color
	background: ${props => props.color};
`;
export const StyledMentionAction: React.FC<IconButtonProps> = styled(IconButton)`
	color: ${props => props.theme.palette.white};
	:hover {
		color: ${props => props.theme.palette.white} !important;
	}
`

